<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content.h-100.overflow-auto(
        style="padding-bottom: 70px;"
      )
        .p-3
          b-row(
            no-gutters
            class="mb-2 align-items-start"
          )
            b-col(
              cols=3,
              class="align-items-center"
            )
              ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-start.justify-content-start.border.border-black(
                :profileUrl="memberInfo ? memberInfo.picture_url : 'xxx'",
                :style="{ 'width': '60px', 'height': '60px' }"
              )
              .text-center.mt-3
                b-button.font-weight-bold.btn-custom(
                  size="sm",
                  variant="remind",
                  @click="updateMemberInfoHandler()",
                  style="border: 0.3rem solid #fff;border-radius: 50px;padding: 5px;border: 3px solid #000;box-shadow: 0.05rem 0.15rem 0 #00000033;"
                )
                  span 資料刷新
            b-col(
              cols=9
            )
              .ml-1
                p.mb-1.font-weight-bold {{ memberInfo ? `${memberInfo.line_display_name}` : '' }}
                p.mb-1.d-flex.align-items-center
                  b-input.d-inline-block(
                    v-model="noteName",
                    :disabled="!editMode",
                    style="border-radius: 20px;",
                    :style="{ 'background-color: #eee;border-0': !editMode, 'background-color: #fff;border-black': editMode }"
                    placeholder="顧客備註名"
                  )
                  b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-2.button.iconBtn.iconEditBtn.border-black.border-width-lg(
                    variant="remind",
                    @click="editModeHandler()"
                  )
                    i.fas.fa-pencil-alt.iconEdit
                p.mb-0.font-weight-bold MARSID：
                  span.mb-0(
                    v-if="memberInfo && memberInfo.mars_id"
                  ) {{ memberInfo.mars_id }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 會籍：{{ memberInfo.card_type }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 會籍到期日：{{ memberInfo.card_expire_date }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 生日：{{ memberInfo.birthday }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 本月/下月/下下月到期點數：<br>{{ memberInfo.expire_point_current_month }}/{{ memberInfo.expire_point_next_month }}/{{ memberInfo.expire_point_next2_month }}
                small.red (提醒) 顧客資訊請勿截圖外流
        b-row.flex-nowrap.no-gutters.px-3(
          style="border-bottom: 0.2rem solid #000; overflow-y: auto;"
        )
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '客戶資料' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('客戶資料')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 客戶資料
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '預約紀錄' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('預約紀錄')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 預約紀錄
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '優惠券' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('優惠券')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 優惠券
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '試用計畫' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('試用計畫')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 試用計畫
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '集點卡'|| nowSelectItem === '集點狀態' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('集點卡')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 集點卡
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '訂單資料' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('訂單資料')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 訂單資料
        .customerInfo.p-3.mb-3.h-100(
          v-show="nowSelectItem === '客戶資料'"
        )
          p.mb-1 顧客喜好：
          multiselect.mb-3(
            v-model="userLabels",
            tag-placeholder="新增顧客喜好",
            placeholder="輸入文字新增顧客喜好",
            selectLabel="點擊新增顧客喜好",
            deselectLabel="點擊移除顧客喜好",
            selectedLabel="已選擇",
            label="tag_name",
            track-by="tag_key",
            group-values="tag",
            group-label="group",
            :options="tagsOption",
            :multiple="true",
            :taggable="true",
            @tag="addLabelHandler",
            @remove="removeLabelHandler",
            @select="selectLabelHandler"
            noOptions="無顧客喜好"
          )
            template(slot="Label", slot-scope='{ tags }')
            template(slot="noOptions")
              strong 請按 Enter 新增顧客喜好
          p.mb-1 顧客描述：
          b-textarea.border-0(
            v-model="desc",
            class="mb-2",
            max-rows="8",
            style="background: #eee;border-radius: 20px;"
          )
          .text-center
            b-button.font-weight-bold.py-1.px-5.btn-custom(
              size="sm",
              variant="remind",
              @click="updateDescriptionHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
            ) 儲存
        .reservationInfo.mb-3(
          v-show="nowSelectItem === '預約紀錄'"
        )
          .p-3
            b-card.border-0.mb-2.customerCard.overflow-hidden(
              bg-variant="white",
              v-for="(reservation,index) in reservations",
              :key="reservation.id",
              v-if="reservations"
            )
              .reserveAtRow.mb-2.d-flex.align-items-center
                small 預約時間：{{ reservation.RegisterDate }}
              .typeRow.mb-2.d-flex.align-items-center
                small 服務內容：{{ reservation.CampaignName }}
              .sourceRow.mb-3.d-flex.align-items-center
                small 來源：Line
              b-row(
                no-gutters,
                class="d-flex justify-content-center",
              )
                b-col(
                  :cols="4"
                )
                  button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
                    size="sm",
                    variant="primary",
                    @click="cancelReservationModalShowHandler(reservation)",
                    style="border: 0.4rem solid #fff;border-radius: 50px;padding: 0px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                  ) 取消預約
              .labelTag(
                v-if="reservation.status === 'expired'",
                style="right: 0;bottom: 0;"
              )
                span.labelTag__text 已過期
            p.mb-0.text-center(
              v-if="reservations.length === 0"
            ) 無預約資料
        .couponInfo.mb-3(
          v-show="nowSelectItem === '優惠券'"
        )
          .col-12.mb-1.pt-2
            .border-0.mb-1(
              v-for="(item, index) in coupons",
              :key="index",
            )
              .p-2.no-gutters.border-bottom.border-black
                p.mb-0.font-weight-bold.f17 {{ item.title }}
                p.mb-0.text-gray {{ item.endTime }}
            p.mb-0.text-center(
              v-if="coupons.length === 0"
            ) 無優惠券資料
            //--------------------------------//
        .trialProgram.mb-3(
          v-show="nowSelectItem === '試用計畫'"
        )
          .p-3
            p.mb-0.text-center(
                v-if="programRecord.length === 0"
              ) 無試用計畫資料
          .point-area
            .point(
              v-for="(status, index) in programRecord"
            )
              img(
                v-if="takeStatus(status) == 0 || takeStatus(status) == 1"
                src='@/assets/images/trial-plan/is_can_take.png'
              )
              img(
                v-else
                src='@/assets/images/trial-plan/is_cant_take.png'
              )
              .status 
                img(:src="require(`@/assets/images/trial-plan/take_status${takeStatus(status)}.png`)")
              .detail
                p 可於
                  span {{ formatDate(status.start_at) }}~
                p
                  span {{ formatDate(status.end_at) }}
                  | 內申請
              .trade-button(v-if='status.is_can_take')
                button.btn(
                    @click='applyPlanHandler(status)'
                    size="sm",
                    variant="primary",
                  ) 申請 >
              .take-date(
                v-if="takeStatus(status) == 1"
              )
                p
                  | 已於
                  br
                  | {{ takeDate[index] }}
                  br
                  |  完成{{ sendStatus[index] }}
              .activity
                img(v-if="isBackNewMember===false" :src="require(`@/assets/images/trial-plan/activity${index+1}.png`)")
                img(v-else :src="require(`@/assets/images/trial-plan/activity${index+1}_2024.png`)")
        .pointsActivityInfo.mb-3.p-2(
          v-if="nowSelectItem === '集點卡'"
        )
          b-card.m-3.border-black.custom-shadow(
            bg-variant="light",
            v-for="(item, index) in memberPointsList",
            :key="item.id"
            @click="changeTypeHandler('集點狀態', item.id)"
          )
            h6.mb-1 {{ item.title }}

          .col-12.mb-1.pt-2
            p.mb-0.text-center(
              v-if="memberPointsList.length === 0"
            ) 無參與集點卡活動
        .pointsSatusInfo.mb-3.p-2(
          v-show="nowSelectItem === '集點狀態'"
        )
          .col-12.mb-1.pt-2
            div.d-flex.align-items-center.justify-content-between
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-2.button.iconBtn.iconEditBtn.border-black.border-width-lg(
                variant="remind",
                @click="changeTypeHandler('集點卡')"
              )
                i.fas.fa-arrow-left
              b-button.border-black.border-width-lg.btn-sm(v-b-modal.member-points-demo-modal, variant="remind") 集點卡 Demo 頁面
            .border-0.m-3(
              v-for="(item, index) in memberPointsStatus",
              :key="item.point_collection_template_mission_id",
            )
              .row.p-2.border-bottom.border-black
                .col-9.d-flex.align-items-center.pr-0
                  span.font-weight-bold 任務{{index+1}}：{{ item.point_collection_template_mission_name }}
                .col-3.d-flex.align-items-center.justify-content-end
                  span(
                    :class="{'text-danger': !item.is_clear, 'text-grey': item.is_clear}"
                  ) {{item.is_clear ? '已達成':'未達成'}}
        .orderInfo.mb-3(
          v-show="nowSelectItem === '訂單資料'"
        )
          .p-3
            .position-relative(v-if="purchaseList.length > 0" v-for="(node, nodeIdx) in purchaseList" :key="node.sourceOrderNumber")
              .order
                div {{ (node.order_date).slice(0, 10) }}
                div {{ node.sourceOrderNumber }} | {{ node.salesRepId }}
                .d-flex.justify-content-between
                  div 小計：
                  div NT$ {{ filterMoney(node.amountWithTax) }}
              .detail
                .toggle.h5(v-b-toggle="node.sourceOrderNumber")
                  b-icon-plus-circle
                  b-icon-dash-circle
                b-collapse.mt-2(:id="node.sourceOrderNumber")
                  .item.mb-2.d-flex.justify-content-between.align-items-center(v-for="(item, itemIdx) in node.purchaseItems" :key="`${item.productName}${itemIdx}`")
                    img(:src="getProductImage(item.productImageUrl)" alt="產品圖" @error="onImageError")
                    div.w-50 {{ item.productName }}
                    .price.align-self-end NT$ {{ filterMoney(item.sellingPriceWithTax) }}
              hr
            p.text-center(v-if="purchaseList.length === 0") 無訂單資料

    b-modal#reservation-cancel-modal(
      title="請填寫預約人資訊",
      centered,
      scrollable,
      hide-header,
      hide-footer,
      v-model="reservationCancelModalShow"
    )
      h5.text-center.mb-3 請填寫預約人資訊
      b-form-input.mb-3.border-black.border-width-lg(
        id="name",
        type="text",
        required,
        trim,
        v-model="reservationCancelForm.register_name",
        placeholder="姓名"
      )
      b-form-input.mb-3.border-black.border-width-lg(
        id="mobile",
        type="tel",
        required,
        trim,
        v-model="reservationCancelForm.register_phone",
        placeholder="手機"
      )
      .row.no-gutters
        .col-6.pr-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="reservationCancelModalShow = false",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
          ) 取消
        .col-6.pl-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="cancelReservationHandler()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
          ) 確認

    b-modal#member-points-demo-modal(
      centered,
      scrollable,
      title="集點卡 Demo"
      header-class="p-2"
      body-class="p-0"
      hide-footer,
    )
      div(v-if="!memberPointsDemoImageUrl") 無圖片
      div(v-else)
        img(:src="memberPointsDemoImageUrl", alt="")
</template>

<script>
import { mapState } from 'vuex';
import $ from 'jquery';
import InfiniteLoading from 'vue-infinite-loading';
import { BIcon, BIconPlusCircle, BIconDashCircle } from 'bootstrap-vue'
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SA_MY_CUSTOMER_RESERVATION_EDIT } from '@/router/sa/my-customer';
import defaultProductImgUrl from '@/assets/images/default/defaultProductImg_YSL.png';

const _ = require('lodash');

export default {
  name: 'MyCustomerModel',
  components: {
    BIcon,
    BIconPlusCircle,
    BIconDashCircle,
    ProfilePhotoSticker,
    InfiniteLoading,
  },
  props: {
    userId: {
      type: [String, Number],
      required: true
    },
    title: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      nowSelectItem: '客戶資料',
      infiniteId: +new Date(),
      noteName: null,
      desc: null,
      editMode: false,
      userLabels: [],
      tagsOption: [],
      reservationCancelModalShow: false,
      reservationCancelForm: {
        member_uuid: null,
        campaign_code: null,
        register_date: null,
        register_section: null,
        register_name: null,
        register_phone: null
      },
      windowScrollHeight: 0, // 視窗原本位置
      memberPointsDemoImageUrl: "",
      takeDate: [],
      sendStatus: [],
    };
  },
  created() {
    const vm = this;
    vm.$EventBus.$on('openMyCustomerModel', () => {
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.commit('sa_my_customer/resetHandler');
      vm.$store.commit('toggleLoading', false);

      // 取得顧客詳細資料
      vm.$store.dispatch('sa_my_customer/getMemberDetailHandler', vm.userId)
        .then(() => {
          vm.$set(vm, 'noteName', vm.memberInfo.note_name);
          vm.$set(vm, 'desc', vm.memberInfo.desc);
          // 取得所有標籤
          vm.$store.dispatch('sa_my_customer/getTagsHandler')
            .then(() => {
              vm.$set(vm, 'tagsOption', vm.tags);
              // 取得該使用者的標籤
              vm.$store.dispatch('sa_my_customer/getMemberTagsHandler', vm.memberInfo.member_line_uuid)
                .then(() => {
                  vm.$set(vm, 'userLabels', vm.memberTags);
                  vm.$swal.close();
                  vm.openModel();
                });
            });
        });
    });
  },
  methods: {
    infiniteHandler(activityId) {
      const vm = this;
      //取得預約紀錄
      if (vm.nowSelectItem === "預約紀錄") {
        vm.$swal.fire({
          title: "取得預約中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        vm.$store
          .dispatch("sa_my_customer/getReservationByIDHandler", {
            m_id: vm.userId,
          })
          .then(() => {
            vm.$swal.close();
          });
        return;
      }
      //取得優惠券紀錄
      if (vm.nowSelectItem === "優惠券") {
        vm.$swal.fire({
          title: "取得優惠券中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        vm.$store.dispatch("sa_my_customer/getCouponByIDHandler", vm.userId).then(() => {
          vm.$swal.close();
        });
        return;
      }
      //取得試用計畫
      if (vm.nowSelectItem === "試用計畫") {
        vm.$swal.fire({
          title: "取得計畫中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        vm.$store
          .dispatch("sa_trial_program/getMemberRecordHandler", vm.userId)
          .then(() => {
            vm.$swal.close();
          });
        return;
      }
      //取得集點卡活動
      if (vm.nowSelectItem === "集點卡") {
        vm.$swal.fire({
          title: "取得集點卡中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        vm.$store
          .dispatch("sa_points_card/getMemberPointsHandler", {
            member_uuid: vm.memberInfo.member_line_uuid,
          })
          .then(() => {
            vm.$swal.close();
          });
        return;
      }
      //取得集點卡任務狀態
      if (vm.nowSelectItem === "集點狀態") {
        vm.$swal.fire({
          title: "取得集點狀態中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        vm.$store
          .dispatch("sa_points_card/getMemberPointsStatusHandler", {
            point_collection_id: activityId,
            member_uuid: vm.memberInfo.member_line_uuid,
          })
          .then(() => {
            vm.$swal.close();
          });
        return;
      }
      // 取得訂單資料
      if(vm.nowSelectItem === '訂單資料') {
        vm.$swal.fire({
          title: '取得訂單資料中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_my_customer/getMemberOrdersHandler', vm.userId)
          .then(() => {
            vm.$swal.close();
        });
         return
      }
    },
    changeTypeHandler(type, activityId) {
      const vm = this;
      switch (type) {
        case "客戶資料":
          if (vm.nowSelectItem === "客戶資料") return;
          vm.nowSelectItem = "客戶資料";
          break;
        case "預約紀錄":
          if (vm.nowSelectItem === "預約紀錄") return;
          vm.nowSelectItem = "預約紀錄";
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteHandler();
          break;
        case "優惠券":
          if (vm.nowSelectItem === "優惠券") return;
          vm.nowSelectItem = "優惠券";
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteHandler();
          break;
        case "試用計畫":
          if (vm.nowSelectItem === "試用計畫") return;
          vm.nowSelectItem = "試用計畫";
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteHandler();
          break;
        case "集點卡":
          if (vm.nowSelectItem === "集點卡") return;
          vm.nowSelectItem = "集點卡";
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteHandler();
          break;
        case "集點狀態":
          if (vm.nowSelectItem === "集點狀態") return;
          vm.nowSelectItem = "集點狀態";
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteHandler(activityId);
          vm.memberPointsDemoImageUrl = vm.memberPointsList.find(
            (item) => item.id === activityId
          ).demo_image_url;
          break;
        case '訂單資料':
          if (vm.nowSelectItem === '訂單資料') return;
          vm.nowSelectItem = '訂單資料';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteHandler();
          break;
        default:
          break;
      }
    },
    editModeHandler() {
      const vm = this;
      if (!vm.editMode) {
        vm.editMode = true;
      } else {
        vm.$swal.fire({
          title: "備註名儲存中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          },
        });

        vm.$store
          .dispatch("sa_my_customer/updateMemberNoteNameHandler", {
            memberId: vm.memberInfo.member_id,
            note_name: vm.noteName,
          })
          .then(() => {
            vm.$swal.close();
            vm.editMode = false;
          });
      }
    },
    async updateDescriptionHandler() {
      const vm = this;

      if (vm.editMode) {
        await vm.editModeHandler();
      }

      vm.$swal.fire({
        title: "顧客描述儲存中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        },
      });

      vm.$store
        .dispatch("sa_my_customer/updateMemberDescHandler", {
          memberId: vm.memberInfo.member_id,
          desc: vm.desc,
        })
        .then(() => {
          vm.$swal.close();
          vm.editMode = false;
        });
    },
    cancelReservationModalShowHandler(reservation) {
      const vm = this;
      if (vm.reservationCancelModalShow) return;
      vm.reservationCancelForm = {
        member_uuid: vm.memberInfo.member_line_uuid,
        campaign_code: reservation.CampaignCode,
        register_date: reservation.RegisterDate,
        register_section: reservation.RegisterSection,
        register_name: reservation.Name,
        register_area: reservation.RegisterArea,
        register_counter: reservation.RegisterCounter,
        register_phone: reservation.Mobile,
      };
      vm.reservationCancelModalShow = true;
    },
    cancelReservationHandler() {
      const vm = this;
      if (
        !vm.reservationCancelModalShow ||
        !vm.reservationCancelForm.member_uuid ||
        !vm.reservationCancelForm.campaign_code ||
        !vm.reservationCancelForm.register_date ||
        !vm.reservationCancelForm.register_section
      ) {
        return;
      } else if (!vm.reservationCancelForm.register_name) {
        vm.$swal.fire({
          icon: "error",
          title: "預約人姓名尚未填寫",
        });
      } else if (!vm.reservationCancelForm.register_phone) {
        vm.$swal.fire({
          icon: "error",
          title: "預約人手機尚未填寫",
        });
      } else {
        vm.$swal.fire({
          title: "取消預約中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        vm.$store
          .dispatch("sa_my_customer/deleteHandler", vm.reservationCancelForm)
          .then(() => {
            vm.$swal.close();
            vm.reservationCancelModalShow = false;
            vm.$store.commit("sa_my_customer/resetHandler");
            vm.infiniteHandler();
          });
      }
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_MY_CUSTOMER_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          userId: this.userId,
          editInfo: reservation,
        },
      });
    },
    confirmReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: "預約確認中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      vm.$store
        .dispatch("sa_my_customer/checkHandler", {
          reservation_id: reservationId,
        })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteId += 1;
        });
    },
    doneReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: "完成預約中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      vm.$store
        .dispatch("sa_my_customer/successHandler", {
          reservation_id: reservationId,
        })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteId += 1;
        });
    },
    addLabelHandler(tag_name) {
      const vm = this;

      setTimeout(() => {
        vm.$swal.fire({
          title: "顧客喜好新增中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
      }, 50);
      // 儲存
      vm.$store
        .dispatch("sa_my_customer/storeTagsHandler", {
          member_uuid: vm.memberInfo.member_line_uuid,
          tags: [
            {
              tag_name,
              type: "new",
              tag_key: null,
              tag_id: null,
            },
            ...vm.userLabels,
          ],
        })
        .then(() => {
          // 初始化標籤
          vm.initTagsHandler();
          vm.$swal.close();
        });
    },
    removeLabelHandler(selectTag) {
      const vm = this;
      setTimeout(() => {
        vm.$swal.fire({
          title: "顧客喜好移除中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
      }, 50);

      // 儲存
      setTimeout(() => {
        vm.$store
          .dispatch("sa_my_customer/storeTagsHandler", {
            member_uuid: vm.memberInfo.member_line_uuid,
            tags: vm.userLabels,
          })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
          });
      }, 50);
    },
    selectLabelHandler() {
      const vm = this;
      setTimeout(() => {
        vm.$swal.fire({
          title: "加上顧客喜好中，請稍候",
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
      }, 50);
      // 儲存
      setTimeout(() => {
        vm.$store
          .dispatch("sa_my_customer/storeTagsHandler", {
            member_uuid: vm.memberInfo.member_line_uuid,
            tags: vm.userLabels,
          })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
          });
      }, 50);
    },
    //試用計畫的狀態
    takeStatus(status) {
      const { is_can_take, take_status, take_date, end_at, step } = status;
      const isEnd = this.duringDateHandler(end_at); //超過可領時間尚未領取

      if (is_can_take === true) {
        // 可以領取
        return 0;
      } else {
        if (take_status === 1) {
          //已領
          const formatDay = this.formatDate(take_date);
          let curday = new Date(formatDay);
          let currMonth = curday.getMonth();
          let currYear = curday.getFullYear();
          let newDay = new Date();
          const today = new Date();

          newDay.setYear(currYear);
          newDay.setMonth(currMonth + 1);
          newDay.setDate(4);

          if (today >= newDay) {
            let newYear = newDay.getFullYear();
            let newMonth = newDay.getMonth();
            this.takeDate[step - 1] = `${newYear}/${
              newMonth + 1 < 10 ? "0" + (newMonth + 1) : newMonth + 1
            }/04`;
            this.sendStatus[step - 1] = "寄送";
          } else {
            this.takeDate[step - 1] = this.formatDate(take_date);
            this.sendStatus[step - 1] = "申請";
          }
          return 1;
        }
        if (!isEnd) {
          return 2; //超過可領時間尚未領取
        }
        return 3; //時間未到不可領
      }
    },
    duringDateHandler(endDateStr) {
      const dateType = endDateStr.replaceAll("-", "/");
      const curDate = new Date();
      const endDate = new Date(dateType);
      if (curDate <= endDate) {
        return true;
      }
      return false;
    },
    formatDate(time, type) {
      if (!time) return;
      if (type === "date") return time.replaceAll("-", "/");
      return time.split(" ")[0].replaceAll("-", "/");
    },
    //申請試用計畫
    applyPlanHandler(status) {
      const vm = this;
      if (!status.is_can_take) return;
      vm.$swal.fire({
        title: "送出申請中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        },
      });
      vm.$store
        .dispatch("sa_trial_program/applyProgramHandler", {
          memberId: vm.userId,
          take_id: status.take_id,
        })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit("sa_my_customer/resetHandler");
          vm.infiniteHandler();
        });
    },
    // 初始化標籤
    initTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: "標籤載入中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      // 取得所有標籤
      vm.$store.dispatch("sa_my_customer/getTagsHandler").then(() => {
        vm.$set(vm, "tagsOption", vm.tags);
        // 取得該使用者的標籤
        vm.$store
          .dispatch("sa_my_customer/getMemberTagsHandler", vm.memberInfo.member_line_uuid)
          .then(() => {
            vm.$set(vm, "userLabels", vm.memberTags);
            vm.$swal.close();
          });
      });
    },
    updateMemberInfoHandler() {
      const vm = this;
      vm.$swal.fire({
        title: "資料刷新中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      const input = {
        cardNo: vm.memberInfo.mars_id,
      };
      vm.$store.dispatch("sa_my_customer/updateMemberCardInfoHandler", input).then(() => {
        vm.$store
          .dispatch("sa_my_customer/getMemberDetailHandler", vm.userId)
          .then(() => {
            vm.$swal.close();
          });
      });
    },
    getProductImage(url) {
      return url && url.trim() !== '' ? url : defaultProductImgUrl;
    },
    onImageError(event) {
      event.target.src = defaultProductImgUrl;
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve, reject) => {
        if ($('#CustomerTempModel').scrollTop() === 0) {
          resolve();
        } else {
          $('#CustomerTempModel').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    // 把視窗移到原本位置
    scrollToTarget() {
      const vm = this;
      return new Promise((resolve, reject) => {
        $('#CustomerTempModel').animate({
          scrollTop: vm.windowScrollHeight
        }, 500);
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').removeClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
  },
  beforeDestroy() {
    this.$store.commit('sa_my_customer/resetHandler');
    this.$EventBus.$off('openMyCustomerModel');
  },
  computed: {
    ...mapState({
      sa_id: (state) => state.sa_profile.data.id,
      reservations: (state) => state.sa_my_customer.reservations,
      reservationTimeList: (state) => state.sa_my_customer.reservationTimeList,
      pagination: (state) => state.sa_my_customer.pagination,
      nowSelectStatus: (state) => state.sa_my_customer.nowSelectStatus,
      memberInfo: (state) => state.sa_my_customer.memberInfo,
      tags: (state) => state.sa_my_customer.tags,
      memberTags: (state) => state.sa_my_customer.memberTags,
      coupons: (state) => state.sa_my_customer.coupons,
      isBackNewMember: (state) => state.sa_trial_program.isBackNewMember,
      programRecord: (state) => state.sa_trial_program.programRecord,
      memberPointsList: (state) => state.sa_points_card.memberPointsList,
      memberPointsStatus: (state) => state.sa_points_card.memberPointsStatus,
      purchaseList: (state) => state.sa_my_customer.purchaseList,
    }),
  }
};
</script>

<style lang="scss" scoped>
@mixin pad {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin mobile {
  @media (max-width: 375px) {
    @content;
  }
}

@mixin small-mobile {
  @media (max-width: 320px) {
    @content;
  }
}
img {
  max-width: 100% !important;
  height: auto;
  vertical-align: center;
  border-style: none;
}
.card {
  border: 0.2rem solid #000 !important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000 !important;
}

.red {
  color: #ef4852;
}

@font-face {
  font-family: "icon";
  src: url("../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

#header_back {
  font-size: 1.7rem;
  padding: 0.5rem;
  position: absolute;
  top: 3%;
  left: 1.6rem;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: #fff !important;
  z-index: 15;
}

i.iconClose {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.2rem;
  margin-bottom: 4px;
}

.iconClose:before {
  content: "\e908";
}

.f17 {
  font-size: 17px;
}

.orderInfo .toggle {
  position: absolute;
  top: 0;
  right: 0;
}
.orderInfo .detail .item {
  font-size: 14px;
}
.orderInfo .detail .item img {
  width: 30%;
  max-width: 80px !important;
  aspect-ratio: 1;
}
.orderInfo .detail .item .price {
  width: 22%
}
.orderInfo .detail .toggle.collapsed .bi-plus-circle{
  display: block
}
.orderInfo .detail .toggle.collapsed .bi-dash-circle{
  display: none
}
.orderInfo .detail .toggle.not-collapsed .bi-plus-circle{
  display: none
}
.orderInfo .detail .toggle.not-collapsed .bi-dash-circle{
  display: block
}
// ----- 試用計畫 -----
.point-area {
  // background: url(../../../assets/images/trial-plan/bg_form.png) top center repeat;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 1% 7% 3% 7%;
  .point {
    flex: 0 0 47%;
    // padding: 2.2% 2.5%;
    position: relative;
    margin-bottom: 5%;
    .status {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    .activity {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }
    .trade-button {
      width: 90%;
      position: absolute;
      left: 50%;
      top: 5%;
      text-align: center;
      z-index: 1;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      padding: 10px;
      background: #fff;
      button {
        // border: 2px solid rgb(0, 0, 0);
        border-radius: 5px;
        padding: 5px 20px;
        background-image: linear-gradient(to right, #e1b547, #e0c074);
        // background: #000;
        color: #fff;
        font-size: 12px;
        @include pad {
          font-size: 18px;
          margin: 10px 0;
        }
        @include small-mobile {
          margin: 0;
          border: 0;
        }
      }
    }
    .detail {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 5%;
      text-align: center;
      @include pad {
        bottom: 5.5%;
      }
      @include small-mobile {
        bottom: 3.5%;
      }
      // margin-top: -2.5rem;
      p {
        margin-bottom: 0;
        font-size: 12px;
        color: #000;
        line-height: 14px;
        text-align: center;
        @include pad {
          font-size: 16px;
          line-height: 18px;
        }
        @include small-mobile {
          line-height: 12px;
        }
      }
      span {
        color: #b90320;
        font-size: 14px;
        padding: 0 2%;
        @include pad {
          font-size: 18px;
        }
        @include small-mobile {
          font-size: 12px;
        }
      }
    }
    .take-date {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 14%;
      z-index: 10;
      text-align: center;
      p {
        color: #000;
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        @include pad {
          font-size: 24px;
          line-height: 28px;
        }
        @include small-mobile {
          font-size: 16px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
